class AppContainerController {
  constructor ($scope, $state, jqService, $timeout, $window, modalService, uiService) {
    this.jqService = jqService;
    this.$timeout = $timeout;
    this.$window = $window;
    this.modalService = modalService;
    this.uiService = uiService;

    this.scrollHeader();
    this.responsiveTabs();
    this.responsiveMenu();

  }
  scrollHeader () {
    var selfController = this;
    this.$timeout(function(){
      selfController.jqService(selfController.$window).scroll(function() {
          if (selfController.jqService(this).scrollTop() > 80) {
               selfController.jqService('#headnav, #nav-trigger').addClass('scrolled');
          } else {
              selfController.jqService('#headnav, #nav-trigger').removeClass('scrolled');
          }
      });
    });
  }

  responsiveTabs () {
      var selfController = this;
      this.$timeout(function(){
          selfController.jqService('#tabslider').easyResponsiveTabs();
      });
  }

    responsiveMenu () {
        var selfController = this;
        this.$timeout(function(){
            selfController.jqService("#nav-mobile").html(selfController.jqService("#nav-main").html());
        });
    }

  showMenu () {
      this.uiService.showMenu();
  }

  showPrivacy () {
      this.modalService.showPrivacy();
  }

    showRefund () {
        this.modalService.showRefund();
    }

    showSecurity () {
        this.modalService.showSecurity();
    }

  getLocation = function(val) {
    return $http.get('//maps.googleapis.com/maps/api/geocode/json', {
      params: {
        address: val,
        sensor: false
      }
    }).then(function(response){
      return response.data.results.map(function(item){
        return item.formatted_address;
      });
    });
  };
}

AppContainerController.$inject = ['$scope', '$state','jqService', '$timeout', '$window', 'modalService', 'uiService'];

export {
  AppContainerController
};



/** WEBPACK FOOTER **
 ** ./src/app/components/appContainer/appContainer.controller.js
 **/